import axios from 'axios';
import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareInvitator } from './Middleware';
import { TokenValidateExpiration } from './Token';

function InviterProvider() {
    var exclusion = document.getElementById("Exclusion");

    var status = false;
    
    if(exclusion.checked) {
        status = true;
    } else {
        status = false;
    }

    document.getElementById("message").style.display = "none";
    document.getElementById("ok").style.display = "none";
    document.getElementById("Chg").style.display = "block";
    document.getElementById("Btn").style.display = "none";


    const token = localStorage.getItem("token");
    const decode = jwtDecode(token);
    const idUser = decode.id;
    const roleUser = decode.role;

    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/inviter/invitation/'+token, {
        RFC: document.getElementById("rfc").value,
        Email: document.getElementById("email").value,
        Token: token,
        IdUser: idUser,
        RoleUser: roleUser,
        Status: status,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    ).then(response => {
        console.log(response.data.success);
        document.getElementById("Chg").style.display = "none";
        document.getElementById("Btn").style.display = "inline-block";

        document.getElementById("ok").style.display = "inline-block";
        document.getElementById("ok").innerHTML = response.data.success;
    })
    .catch(error => {
        console.log( error.response.data.error);
        document.getElementById("Chg").style.display = "none";
        document.getElementById("Btn").style.display = "inline-block";

        document.getElementById("message").style.display = "inline-block";
        document.getElementById("message").innerHTML = error.response.data.error;
    });
}

function Inviter() {
    Middleware();
    MiddlewareInvitator();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    var decode = "";

    decode = jwtDecode(token);

    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        decode.email
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Solicitud de alta de proveedor</h1>
                        <br></br>
                        <form action={InviterProvider}>
                            <div className='d-flex justify-content-center'>
                                <label id='ok' className='Success-Notification'></label>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <label id='message' className='Error-Notification'></label>
                            </div>
                            <br></br>
                            <br></br>
                            <input type='text' id='rfc' className='Input-Style' placeholder='RFC'></input>
                            <br></br>
                            <input type='email' id='email' className='Input-Style' placeholder='Email'></input>
                            <br></br>
                            <br></br>
                            {
                                decode.email == "ddoctori@proveedoresgh.com"
                                ?
                                <div>
                                    <label><input type='checkbox' id="Exclusion"></input> Excluir validaciones</label>
                                    <br></br>
                                    <br></br>
                                </div>
                                :
                                <div>
                                    <input type='hidden' id="Exclusion" value="false"></input>
                                </div>
                            }
                            <i id="Chg"className="fa fa-spinner fa-spin Chg"></i>
                            <input id='Btn' type='submit' className='Button-Style'></input>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Inviter;